
import Vue, { VueConstructor, PropType } from 'vue'
import RModal from './index.vue'
import { ConnectionDetails } from '@/store/types/drive'
import { RIcon, RTooltip, RVideo } from '@/components'
import CopyText from '@/mixins/CopyText'

type DetailRow = {
  property: string
  propertyFullName: string
  value: string | number
}

type StorageConnectionDataModalState = {
  passwordShown: boolean
  selectedSoftware: 'cyberduck' | 'filezilla'
}

const propertyFullNameMapping = {
  // Common
  protocol: 'Protocol',
  port: 'Port',
  accessKeyId: 'Access Key ID',
  secretAccessKey: 'Secret Access Key',
  // Cyberduck
  server: 'Server',

  // FileZilla Pro
  host: 'Host',
  defaultRemoteDirectory: 'Default remote directory (Advanced tab)',
}

export default (Vue as VueConstructor<Vue & InstanceType<typeof CopyText>>).extend({
  name: 'StorageConnectionDataModal',
  components: {
    RModal,
    RIcon,
    RTooltip,
    RVideo,
  },
  data(): StorageConnectionDataModalState {
    return {
      passwordShown: false,
      selectedSoftware: 'cyberduck',
    }
  },
  mixins: [CopyText],
  props: {
    connectionDetails: {
      type: Object as PropType<ConnectionDetails>,
      required: true,
    },
  },
  methods: {
    setPasswordShown(newValue: boolean): void {
      this.passwordShown = newValue
    },
    selectCyberduck() {
      this.selectedSoftware = 'cyberduck'
    },
    selectFilezilla() {
      this.selectedSoftware = 'filezilla'
    },
  },
  computed: {
    details(): DetailRow[] {
      const keysCyberduck: string[] = [
        'protocol',
        'port',
        'server',
        'accessKeyId',
        'secretAccessKey',
      ]

      const keysFilezilla: string[] = [
        'protocol',
        'port',
        'host',
        'accessKeyId',
        'secretAccessKey',
        'defaultRemoteDirectory',
      ]

      const keys = this.selectedSoftware === 'cyberduck' ? keysCyberduck : keysFilezilla

      return keys.map((key) => {
        return {
          property: key,
          value: this.connectionDetails[key as keyof ConnectionDetails],
          propertyFullName: propertyFullNameMapping[key as keyof ConnectionDetails],
        } as DetailRow
      })
    },
    softwareName(): string {
      return this.selectedSoftware === 'cyberduck' ? 'Cyberduck' : 'FileZilla Pro'
    },
    copyTooltipText(): string {
      return this.successfullyCopiedText ? 'Copied!' : 'Copy'
    },
  },
})
